import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

// import logo from '../assets/images/logo/logo_shweet.avif';
import logo from "../assets/images/logo/logo_shweet.png";
import { navigation_data } from "../core/navigation";
import { useAuth } from "../context/AuthContext";

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    let prompt_value = window.confirm("Are you sure you want to logout?");
    if (!prompt_value) return;
    logout();
    navigate("/sign-in");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-white bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} className="logo" alt="logo" />
          </Link>

          <button
            // style={{ borderRadius: '50%', padding: '10px' }}
            className="avatar-btn xnavbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            onClick={() => {
              handleLogout();
            }}
          >
            {/* <span className="navbar-toggler-icon"></span> */}
            <span className="p-2">{(user && user.username) || ""}</span>{" "}
            <i className="fa fa-sign-out-alt"></i>
          </button>

          {/* <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active fw-bold" : "")
                    }
                  >
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/about"
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active fw-bold" : "")
                    }
                  >
                    About
                  </NavLink>
                </li>
              </ul>
            </div> */}
        </div>
      </nav>

      <div id="footer-bar" className="footer-bar-1 xmb-4">
        {navigation_data.map(
          (item, index) =>
            item.is_tabbar && (
              <NavLink
                to={item.path}
                // className={` ${window.location.path==item.path?"active-nav":""}`}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active-nav" : ""}`
                }
                // style={{backgroundColor:"red"}}
              >
                <i className={item.icon} />
                {/* <span>{item.name}</span> */}
              </NavLink>
            )
        )}

        {/* <a href="index-components.html"><i className="fa fa-star" /><span>Features</span></a>
            <a href="index-pages.html"><i className="fa fa-heart" /><span>Pages</span></a>
            <a href="index-search.html"><i className="fa fa-search" /><span>Search</span></a>
            <a href="#" data-menu="menu-settings"><i className="fa fa-cog" /><span>Settings</span></a> */}
      </div>
    </>
  );
}

export default Navbar;
